import React from "react";

import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../styles/new-search-widget.module.scss";
import {NewSearchWidgetBackButton} from "./new-search-widget.back-button";
import {NewSearchWidgetSportsFilter} from "./sports-filter/new-search-widget.sports-filter";
import {NewSearchWidgetInput} from "./new-search-widget.input";

export const NewSearchWidgetHeader = observer(({controller}) => {
  const {state} = controller;
  const {isListSingleView, listSingleViewTitle} = state;

  return (
    <div className={classNames(styles.header, {[styles.single_view_header]: isListSingleView})}>
      <NewSearchWidgetBackButton controller={controller}/>
      {
        !isListSingleView ? <div className={classNames(styles.search_container)}>
          <NewSearchWidgetSportsFilter controller={controller}/>
          <NewSearchWidgetInput controller={controller}/>
        </div> : <div className={classNames(styles.header_title)}>{listSingleViewTitle}</div>
      }
    </div>
  )
});
